import { initializePinterestTag } from '@src/quince-site-common/src/trackers/PinterestInitializer'
import { initializeScript } from '@src/telemetry/integrations/provider-utils/initialize-script'
import { TelemetryIntegration } from '@src/telemetry/telemetry-events.types'

import { TELEMETRY_EVENT_NAMES } from '../telemetry-events.constants'
import { TELEMETRY_DOMAINS } from '../telemetry-domains.constants'

export const PinterestTag: TelemetryIntegration = {
  config: {
    enabled: true,
    eventIdealTimeout: 1000,
    domain: TELEMETRY_DOMAINS.PINTEREST_TAG,
  },

  initialize: async () => {
    if (!window.pintrk) {
      window.pintrk = function (...args: unknown[]) {
        if (window.pintrk) {
          if (!window.pintrk.queue) {
            window.pintrk.queue = []
          } else {
            window.pintrk.queue.push(args)
          }
        }
      }
      window.pintrk.queue = []
      window.pintrk.version = '3.0'
    }

    await initializeScript({
      key: 'pinterest-tag',
      domain: TELEMETRY_DOMAINS.PINTEREST_TAG,
      path: '/ct/core.js',
      injectAt: 'beforeFirstScript',
      onLoad: initializePinterestTag,
    })
  },

  events: {
    [TELEMETRY_EVENT_NAMES.ADD_TO_CART]: properties => {
      if (window.pintrk) {
        window.pintrk('track', 'addtocart', {
          currency: 'USD',
          event_id: properties.eventId,
          line_items: [
            {
              product_id: properties.productId,
              product_variant_id: properties.variantId,
              product_name:
                properties.productTitle && properties.variantTitle
                  ? properties.productTitle + ' - ' + properties.variantTitle
                  : '',
              product_price: properties.price,
              product_quantity: properties.quantity || 1,
            },
          ],
        })
      }
    },

    [TELEMETRY_EVENT_NAMES.PRODUCT_VIEW]: properties => {
      if (window.pintrk) {
        window.pintrk('track', 'pagevisit', {
          currency: 'USD',
          event_id: properties.eventId,
          line_items: [
            {
              product_id: properties.productId,
              product_variant_id: properties.variantId,
              product_name:
                properties.productTitle && properties.variantTitle
                  ? properties.productTitle + ' - ' + properties.variantTitle
                  : '',
              product_price: properties.price,
              product_quantity: 1,
            },
          ],
        })
      }
    },

    [TELEMETRY_EVENT_NAMES.SEARCH]: properties => {
      if (window.pintrk)
        window.pintrk('track', 'search', {
          event_id: properties.eventId,
          search_query: properties.searchQuery,
        })
    },

    [TELEMETRY_EVENT_NAMES.COLLECTION_VIEW]: properties => {
      if (window.pintrk) {
        const productIds = Array.from(new Set(properties.variantList.map(x => x.product_id)))
        window.pintrk('track', 'viewcategory', {
          event_id: properties.eventId,
          line_items: [
            {
              product_category: properties.collectionTitle,
              product_variant_id: productIds,
            },
          ],
        })
      }
    },
  },
}
